import { html, svg } from 'lit'

export const NotFoundIcon = () => html`<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  ${svg`<path d="M512 0V512H0V0H512zM464 48H48V464H464V48z"/>`}
</svg>`
